'use client';

import { useEffect, useState } from 'react';
import { authBus } from '@/lib/auth-bus';
import { InviteCodeDialog } from '@/components/InviteCodeDialog';
import { useTranslation } from '@/hooks/useTranslation';

export function InvalidInvitationDialog() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    authBus.onInvalidInvitation(handler);
    return () => authBus.offInvalidInvitation(handler);
  }, []);

  return (
    <InviteCodeDialog
      open={open}
      onOpenChange={setOpen}
      message={t('login.inviteDialog.invalidMessage')}
    />
  );
}
